import { FC } from 'react'
import { formatSum } from '../../../../../utils'
import { KIND_LABEL, PARTICIPANT_LABEL } from '../../core/consts'
import { RevisionPreview } from '../../core/response.types'

const signed = (value: string, currency: string): string => {
  const n = Number(value)
  const sign = n > 0 ? '+' : n < 0 ? '−' : ''

  return `${sign}${formatSum(Math.abs(n))} ${currency}`
}

// What a revision will post, per participant: the body and the commissions it changes, as Ledger
// priced them on a dry run.
export const SettlementPreview: FC<{ preview: RevisionPreview }> = ({ preview }) => (
  <div className='border rounded p-3 mb-3'>
    <div className='fw-bold mb-2'>Что будет проведено</div>
    {preview.rows.length === 0 && <div className='text-muted'>Проводок в учёте не будет</div>}
    {preview.rows.map((row) => (
      <div
        key={`${row.participant}-${row.currency}`}
        className='d-flex justify-content-between align-items-center small mb-1'
      >
        <span>
          {PARTICIPANT_LABEL[row.participant]}
          {row.historyKind && (
            <span className='badge badge-light-primary ms-2'>{KIND_LABEL[row.historyKind]}</span>
          )}
        </span>
        <span className='text-end'>
          {Number(row.body) !== 0 && <span>{signed(row.body, row.currency)}</span>}
          {Number(row.fee) !== 0 && (
            <span className='text-muted ms-2'>
              комиссия <span>{signed(row.fee, row.currency)}</span>
            </span>
          )}
        </span>
      </div>
    ))}
    {preview.resendAmount && (
      <div className='small mt-2'>
        Получателю дошлём {formatSum(preview.resendAmount)} отдельной выплатой
      </div>
    )}
    {preview.newCreditedAmount && (
      <div className='small mt-1'>
        Сумма зачисления станет {formatSum(preview.newCreditedAmount)}, мерчант получит уведомление
      </div>
    )}
  </div>
)
